import { Bot, FileJson, FileText, Folder, NotepadText, SquareTerminal } from "lucide-react"

interface ReportPanelHeaderPanelProps {
    children?: React.ReactNode
    state: "details" | "type" | "documents" | "additional" | "additional_details" | "summary" | "done"
}
export function ReportPanelHeaderPanel({ children, state }: Readonly<ReportPanelHeaderPanelProps>) {
    return (
        <div className="flex flex-row items-center p-3">
            <div className="flex-1 flex-col flex-shrink-0">
                <div className="text-2xl font-semibold leading-none tracking-tight flex items-center gap-2">
                    {
                        state === "details" &&
                        <>
                            <FileText className="h-5 w-5" />
                            Report Details
                        </>
                    }
                    {
                        state === "type" &&
                        <>
                            <FileJson className="h-5 w-5" />
                            Select Type
                        </>
                    }
                    {
                        state === "documents" &&
                        <>
                            <Folder className="h-5 w-5" />
                            Select Documents
                        </>
                    }
                    {
                        state === "additional" &&
                        <>
                            <Folder className="h-5 w-5" />
                            Select Additional Documents
                        </>
                    }
                    {
                        state === "additional_details" &&
                        <>
                            <SquareTerminal className="h-5 w-5" />
                            Add Template Information
                        </>
                    }
                    {
                        state === "summary" &&
                        <>
                            <NotepadText className="h-5 w-5" />
                            Report Generation Summary
                        </>
                    }
                    {
                        state === "done" &&
                        <>
                            <Bot className="h-5 w-5" />
                            Report Generation
                        </>
                    }
                </div>
                <p className="text-sm text-gray-600">
                    {
                        state === "details" &&
                        "Give your report a clear name and description."
                    }
                    {
                        state === "type" &&
                        "Select the report type and the related template."
                    }
                    {
                        state === "documents" &&
                        "Search and select documents from the NFWF Document Repository to add to your report."
                    }
                    {
                        state === "additional" &&
                        "(Optional) Most Reports will not require this."
                    }
                    {
                        state === "additional_details" &&
                        "Add template information to customize your report."
                    }
                    {
                        state === "summary" &&
                        "Review configuration for the current following report generation before starting the process."
                    }
                    {
                        state === "done" &&
                        "Report Generation is going to start soon"
                    }
                </p>
            </div>
            {children}
        </div>
    )
}
